import { LABELS_MAP_BRICO } from 'client/fragments/listerFragment/constants'

export const getLabel = label => LABELS_MAP_BRICO[label] || label
